<form
  class="informative-page-form"
  fxLayout="column"
  fxLayoutGap="20px"
  [formGroup]="subscriptionPageForm"
  dashboardConnectForm
  [connectForm]="isEdit ? selectedInformativePage : null"
>
  <div fxLayout="column">
    <mat-tab-group
      mat-align-tabs="end"
      #languageTabs
      (selectedTabChange)="selectTemplateLanguage($event)"
      [disablePagination]="true"
      [selectedIndex]="selectedLanguage?.tabIndex"
      (animationDone)="selectFirstTab()"
    >
      <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
        <ng-container *ngTemplateOutlet="tabContent"></ng-container>
      </mat-tab>
    </mat-tab-group>
    <ng-template #tabContent>
      <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
        <mat-form-field
          [formGroupName]="i"
          *ngIf="item.get('language').value === selectedLanguage.code && item.get('identifier').value === 'title'"
          fxFill
        >
          <input matInput formControlName="translation" placeholder="Informative page title" />
          <mat-error *ngIf="item.get('identifier').value === 'title' && item.get('translation').hasError('required')">
            Informative page title is <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </ng-template>
  </div>
  <div *ngIf="selectedStudy?.type === StudyType.TIIM" fxLayout="column">
    <mat-checkbox color="primary" formControlName="isThanks">This is thank you page</mat-checkbox>
  </div>
  <div fxLayout="column" *ngIf="isEmail.value">
    <mat-checkbox formControlName="isEmail">Email page</mat-checkbox>
  </div>
  <div fxLayout="column">
    <mat-tab-group
      mat-align-tabs="end"
      animationDuration="0ms"
      #languageTabsEditor
      (selectedTabChange)="selectTemplateLanguage($event)"
      [disablePagination]="true"
      [selectedIndex]="selectedLanguage?.tabIndex"
      (animationDone)="selectFirstTab()"
    >
      <mat-tab *ngFor="let language of supportedLanguages" [label]="language.name">
        <ng-template matTabContent>
          <div formArrayName="translations" *ngFor="let item of translations?.controls; let i = index">
            <div
              [formGroupName]="i"
              *ngIf="
                item.get('language').value === selectedLanguage?.code && item.get('identifier').value === 'content'
              "
              fxFill
            >
              <editor formControlName="translation" [init]="tinymceInitConfig"></editor>
              <mat-error class="informative-page-form__label" *ngIf="item.invalid && formSubmitted">
                Page content is <strong>required</strong>
              </mat-error>
            </div>
          </div>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  </div>
  <dashboard-image-upload
    *ngIf="selectedStudy?.type !== StudyType.CC"
    formControlName="imagePath"
    [label]="'Image'"
    [isEdit]="isEdit"
    [isImageToEdit]="isImageToEdit"
    [imgPath]="imgPath"
    [keyForUpload]="keyForUpload"
    [idsForUpload]="idsForUpload"
  >
  </dashboard-image-upload>
  <div class="informative-page-form__actions" fxLayoutAlign="end">
    <button mat-raised-button color="accent" (click)="savePage()">
      {{ 'Save page' | uppercase }}
    </button>
  </div>
</form>
